import React,{useEffect,useState} from 'react';



const avatarSrc=(id)=>{
  switch(id){
    case 0:
    return require('../../../image/avatars/Anonyme.png')
    case 1:
    return require('../../../image/avatars/Vieille_Dame.png')
    case 2:
    return  require('../../../image/avatars/Aventurier.png')
    case 3:
    return  require('../../../image/avatars/Chasseur.png')
    case 4:
    return  require('../../../image/avatars/Dame_Tenue_Soleil.png')
    case 5:
    return  require('../../../image/avatars/Derrick.png')
    case 6:
    return  require('../../../image/avatars/Femme_TrenteAns.png')
    case 7:
    return  require('../../../image/avatars/Homme_TrenteAns.png')
    case 8:
    return  require('../../../image/avatars/Jeune_Femme.png')
    case 9:
    return  require('../../../image/avatars/Jeune_Femme.png')
    case 10:
    return  require('../../../image/avatars/Joggeuse.png')
    case 11:
    return  require('../../../image/avatars/Julien.png')
    case 12:
    return  require('../../../image/avatars/Philippe.png')
    case 13:
    return  require('../../../image/avatars/Plongeur_2.png')
    case 14:
    return  require('../../../image/avatars/Professionnelle.png')
    case 15:
    return  require('../../../image/avatars/Reine_Angleterre.png')
    case 16:
    return  require('../../../image/avatars/Afro.png')
    default:
    return require('../../../image/avatars/Anonyme.png')

  }

}




const Avatar = (props) =>{
  const [source, setSource] = useState(require('../../../image/avatars/Anonyme.png'));
  useEffect(()=>{
    setSource(avatarSrc(props.id_avatar))
  },[props.id_avatar])
  return <img className={props.className}  style={{...props.style}} className={props.className} src={source} />
}


export default Avatar;
